import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { IdLocaBalancing } from "../balancing/types/BalancingCore";
import { IdIcon } from "../generic/icon/IdIcon";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdExternalBarnCategory } from "./IdExternalBarnCategory";
var _MenuExternalBarnUpgrade = function (_a) {
    var onClose = _a.onClose;
    var upgradeTab = [
        {
            icon: IdIcon.UpgradeIcn,
            id: IdExternalBarnCategory.Upgrade,
            locaKey: IdLocaBalancing.upgrade,
            name: "Upgrade",
        },
    ];
    return (React.createElement(MenuWrapper, { type: IdMenuBalancing.ExternalBarn, customTabs: upgradeTab, onClose: onClose, modalId: IdModal.ExternalBarnUpgrade }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ExternalBarnUpgrade)); },
}); };
export var MenuExternalBarnUpgrade = connect(undefined, mapDispatch)(_MenuExternalBarnUpgrade);



//////////////////
// WEBPACK FOOTER
// ./src/features/external-barn/MenuExternalBarnUpgrade.tsx
// module id = 2823
// module chunks = 3